import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, Loader2, CheckCircle2, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [state, setState] = useState({ phase: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setState({ phase: "error", msg: "Passwords don't match." });
      return;
    }
    setState({ phase: "loading", msg: "" });
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, password });
      setState({ phase: "success", msg: data.message });
    } catch (err) {
      const d = err.response?.data?.detail;
      setState({ phase: "error", msg: typeof d === "string" ? d : "Reset failed — request a fresh link." });
    }
  };

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-2xl bg-white border border-black/5 shadow-lg p-8">
        <div className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-lg bg-trust flex items-center justify-center">
            <ShieldCheck size={18} className="text-white" />
          </span>
          <span className="font-display font-bold text-xl">ProofBuy</span>
        </div>

        {state.phase === "success" ? (
          <div className="mt-6">
            <p data-testid="reset-success" className="flex items-center gap-2 text-sm font-semibold text-verified">
              <CheckCircle2 size={16} /> {state.msg}
            </p>
            <Link data-testid="reset-back-link" to="/" className="mt-5 inline-block text-sm font-semibold text-trust hover:text-trust-dark transition-colors duration-200">
              Back to ProofBuy — sign in with your new password
            </Link>
          </div>
        ) : (
          <form data-testid="reset-password-form" onSubmit={submit} className="mt-6">
            <p className="text-sm text-gray-500">Choose a new password for your reviewer account.</p>
            <input data-testid="reset-password-input" type="password" required minLength={8} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ characters)" autoComplete="new-password"
              className="mt-5 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none focus:border-trust" />
            <input data-testid="reset-confirm-input" type="password" required minLength={8} value={confirm}
              onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat it" autoComplete="new-password"
              className="mt-3 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none focus:border-trust" />
            <button data-testid="reset-submit-button" type="submit" disabled={state.phase === "loading"}
              className="mt-5 w-full rounded-full bg-trust text-white font-semibold py-3 transition-colors duration-200 hover:bg-trust-dark disabled:opacity-60 flex items-center justify-center gap-2">
              {state.phase === "loading" ? <Loader2 size={16} className="animate-spin" /> : "Reset password"}
            </button>
            {state.msg && (
              <p data-testid="reset-error" className="mt-3 flex items-center gap-2 text-sm font-semibold text-warn">
                <AlertCircle size={15} /> {state.msg}
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
